import { render, staticRenderFns } from "./PasoRevisarPago.vue?vue&type=template&id=4de28ccb&scoped=true"
import script from "./PasoRevisarPago.vue?vue&type=script&lang=js"
export * from "./PasoRevisarPago.vue?vue&type=script&lang=js"
import style0 from "./PasoRevisarPago.vue?vue&type=style&index=0&id=4de28ccb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de28ccb",
  null
  
)

export default component.exports